import { AssessmentTestContextType } from '..';
import { closeOpenIntervals, openInterval, queueForSync } from '../helpers';

export type UpdateStepActiveSectionActionType = {
  type: 'UPDATE_STEP_ACTIVE_SECTION';
  payload: {
    sectionId: string;
    timestamp: Date;
  };
};

export const INTRODUCTION_SECTION_ID = 'introduction';

export function updateStepActiveSectionReducer(
  state: AssessmentTestContextType,
  action: UpdateStepActiveSectionActionType
) {
  if (state.screen.type !== 'STEP') {
    throw new Error(
      'UPDATE_STEP_ACTIVE_SECTION can only be called when in step screen'
    );
  }

  if (action.payload.sectionId === state.screen.sectionId) {
    return state;
  }

  const stepId = state.screen.stepId;
  const timestamp = action.payload.timestamp;

  return {
    ...state,
    ...queueForSync(state),
    screen: {
      ...state.screen,
      sectionId: action.payload.sectionId,
    },
    steps: state.steps.map((step) =>
      step.id === stepId
        ? handleStepSectionChange({
            timestamp,
            sectionId: action.payload.sectionId,
            step,
          })
        : step
    ),
  };
}

function handleStepSectionChange({
  timestamp,
  sectionId,
  step,
}: {
  timestamp: Date;
  sectionId: string;
  step: AssessmentTestContextType['steps'][number];
}) {
  return {
    ...step,
    ...(!step?.introduction
      ? {}
      : {
          introduction: {
            ...step.introduction,
            timeIntervals:
              sectionId === INTRODUCTION_SECTION_ID
                ? openInterval({
                    existingIntervals: step.introduction.timeIntervals,
                    timestamp,
                  })
                : closeOpenIntervals({
                    existingIntervals: step.introduction.timeIntervals,
                    timestamp,
                  }),
          },
        }),
    sections: step.sections.map((section) => ({
      ...section,
      timeIntervals:
        sectionId === section.id
          ? openInterval({
              existingIntervals: section.timeIntervals,
              timestamp,
            })
          : closeOpenIntervals({
              existingIntervals: section.timeIntervals,
              timestamp,
            }),
    })),
  };
}
